module.exports = __webpack_public_path__ + "static/20-c7f7f2ab18885e809a95a8a4bf6620c2.jpg";